import { sb } from './supabase';

export const DECISION_TYPE_LABEL = {
  scenario_selection: 'Scenario selection',
  requirement_change: 'Requirements change',
};

/** Raise a governance decision to unlock the requirements baseline for edits. */
export async function requestRequirementChange({
  programmeId,
  projectId,
  rationale,
  profileId,
  profileName,
}) {
  if (!rationale?.trim()) throw new Error('Rationale is required');
  const { data, error } = await sb
    .from('governance_decisions')
    .insert({
      programme_id: programmeId,
      project_id: projectId,
      title: 'Requirements baseline change request',
      description: rationale.trim(),
      decision_type: 'requirement_change',
      status: 'pending',
      created_by: profileId || null,
      decided_by_name: profileName || null,
    })
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

/** Approve a change request — clears baseline lock and reopens requirements for edit. */
export async function approveRequirementChange(decisionId, projectId, profile) {
  const { error: decErr } = await sb
    .from('governance_decisions')
    .update({
      status: 'made',
      decision_date: new Date().toISOString().slice(0, 10),
      decided_by_name: profile?.full_name || profile?.email || 'Approver',
    })
    .eq('id', decisionId)
    .eq('decision_type', 'requirement_change');

  if (decErr) throw decErr;

  const { error: projErr } = await sb
    .from('projects')
    .update({
      requirements_baseline_locked_at: null,
      requirements_baseline_locked_by: null,
    })
    .eq('id', projectId);

  if (projErr) throw projErr;

  await sb
    .from('requirements')
    .update({ status: 'approved' })
    .eq('project_id', projectId)
    .eq('status', 'baselined');
}

export async function fetchPendingChangeRequests(projectId) {
  const { data, error } = await sb
    .from('governance_decisions')
    .select('*')
    .eq('project_id', projectId)
    .eq('decision_type', 'requirement_change')
    .in('status', ['proposed', 'pending'])
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}
